/**
 * Adaptador del vendedor/usuario autenticado.
 *
 * Fuente real en este proyecto: store.usuarioActual
 * (persistido en localStorage como "usuarioActual").
 *
 * Nota: store.usuarios existe, pero corresponde al listado administrativo
 * de usuarios (getUsuarios), no al usuario de la sesión activa.
 *
 * TODO futuro: mapear también teléfono real cuando exista en el backend.
 */

const ADMIN_ROLES = ["Administrador", "Super Administrador"];

export const getCurrentSeller = (store) => {
	const user = store?.usuarioActual || null;

	const nombreCompleto = [user?.nombre, user?.apellido]
		.filter(Boolean)
		.join(" ")
		.trim();

	return {
		id: user?.id != null ? String(user.id) : "usuario-demo",
		nombre: nombreCompleto || user?.nombre || "Usuario de prueba",
		correo: user?.correo || "usuario@denegocios.cl",
		// Teléfono no viene hoy en usuarioActual; valor temporal para el mockup.
		telefono: user?.telefono || "+56 9 0000 0000",
		rol: user?.tipo || "usuario",
		isAdmin: ADMIN_ROLES.includes(user?.tipo),
		raw: user,
	};
};

export const isAdminSeller = (seller) =>
	Boolean(seller?.isAdmin) || ADMIN_ROLES.includes(seller?.rol);
